module.exports = __webpack_public_path__ + "img/bingo_ball-45.9d2157a4.png";